import { Component, OnInit, Input } from "@angular/core";
import {
  trigger,
  state,
  style,
  animate,
  transition,
  query,
  stagger,
  keyframes,
} from "@angular/animations";
import { LessonCard } from "../../Models/lessons.interface";
import { UserManager } from "../../Services/UserManager/user-manager";
import { LessonManagerService } from "../../Services/LessonManager/lesson-manager.service";
import { LanguageSwitchService } from "../../Services/LanguageSwitch/language-switch.service";

@Component({
  selector: "app-lesson-header-bar",
  templateUrl: "./lesson-header-bar.component.html",
  styleUrls: ["./lesson-header-bar.component.css"],
  animations: [
    trigger("imageTrigger", [
      state(
        "show",
        style({
          transform: "scale(1)",
        })
      ),
      state(
        "void",
        style({
          transform: "scale(0)",
        })
      ),
      transition("* => show", [
        animate(
          "400ms",
          keyframes([
            style({ transform: "scale(0)", offset: 0.1 }),
            style({ transform: "scale(0.4)", offset: 0.2 }),
            style({ transform: "scale(1.2)", offset: 0.4 }),
            style({ transform: "scale(0.9)", offset: 0.7 }),
            style({ transform: "scale(1)", offset: 0.9 }),
          ])
        ),
      ]),
    ]),
    trigger("backgroundTrigger", [
      state(
        "show",
        style({
          transform: "translateX(0)",
          opacity: 1,
        })
      ),
      state(
        "void",
        style({
          transform: "translateX(20%) scale(0)",
          opacity: 0,
        })
      ),
      transition("* => show", [animate("400ms 150ms ease-out")]),
      transition("show => *", [animate("400ms 150ms ease-out")]),
    ]),
  ],
})
export class LessonHeaderBarComponent implements OnInit {
  @Input() lessonCard: LessonCard;
  imageState = "void";
  backgroundState = "void";
  allState;
  config;
  constructor(
    private um: UserManager,
    private lm: LessonManagerService,
    private ls: LanguageSwitchService
  ) {
    this.ls.config.subscribe({
      next: (config) => {
        this.config = config;
      },
    });
  }

  ngOnInit() {
    this.allState = true;
    this.imageState = "show";
    this.backgroundState = "show";
  }

  setLesson(lesson: LessonCard) {
    this.allState = true;

    this.lessonCard = lesson;
    this.imageState = "show";
    this.backgroundState = "show";
  }
}
